import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["group", "columns", "excluded"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { FILL_OUT_SECTIONS } from "@Client/@Utils/enums";
import { getField } from "@joandvgv/vuex-map-fields";
import { arrayToJsonPath, stringToHash } from "@Shared/utils/utils";
import { chain, groupBy } from "lodash";
export const GET_APPLICATION_SCHEMA_CARDS = "GET_APPLICATION_SCHEMA_CARDS";
export const VALIDATIONS_BY_JSON_PATH = "VALIDATIONS_BY_JSON_PATH";
export const APPLICATIONS_BY_SUBDOMAIN = "APPLICATIONS_BY_SUBDOMAIN";
export const TOTAL_APPLICATIONS = "TOTAL_APPLICATIONS";
export const IS_CONSOLIDATED_REQUEST = "IS_CONSOLIDATED_REQUEST";
export const CONSOLIDATED_REQUEST_FILL_OUT = "CONSOLIDATED_REQUEST_FILL_OUT";
export const CONSOLIDATED_REQUEST_CLIENT_USERNAME = "CONSOLIDATED_REQUEST_CLIENT_USERNAME";
export const CONSOLIDATED_REQUEST_SECTIONS = "CONSOLIDATED_REQUEST_SECTIONS";
export const APPLICATION_DETAILS_FLOW = "APPLICATION_DETAILS_FLOW";
export const APPLICATION_STATUS = "APPLICATION_STATUS";
export const CONSOLIDATED_REQUEST_CO_APPLICANTS_DETAILS_REQUESTED = "CONSOLIDATED_REQUEST_CO_APPLICANTS_DETAILS_REQUESTED";
export const MAIN_APPLICANT_WILL_FILL_OUT_COAPPLICANTS_DETAILS = "MAIN_APPLICANT_WILL_FILL_OUT_COAPPLICANTS_DETAILS";
const populateColumns = (columns, metadata, flow, cardTitle, excluded = []) => {
  if (typeof columns === "string") {
    var _context;
    const {
      columns: populated,
      "group-title": groupTitle,
      "empty-by-default": defaultEmpty = false,
      //eslint-disable-next-line
      multi = false
    } = metadata["group-rules"][columns];
    return _mapInstanceProperty(_context = _filterInstanceProperty(populated).call(populated, ({
      key
    }) => !_includesInstanceProperty(excluded).call(excluded, key))).call(_context, column => {
      return _objectSpread(_objectSpread({}, column), {}, {
        subGroup: columns,
        subGroupTitle: cardTitle,
        groupTitle,
        "empty-by-default": defaultEmpty,
        visible: column.visible[flow],
        validation: column.validation[flow]
      });
    });
  }
  return columns;
};
export default {
  getField,
  [GET_APPLICATION_SCHEMA_CARDS]: state => page => {
    var _context2;
    const pageData = state.schema.pages.byKey[page];
    const flow = state.application.flow;
    if (!pageData) return [];
    const groups = _valuesInstanceProperty(_context2 = chain(pageData.sections).groupBy("card")).call(_context2).value();
    return _mapInstanceProperty(groups).call(groups, card => {
      var _context3;
      const [first] = card;
      return {
        title: first["card-title"],
        subtitle: first["card-subtitle"],
        detail: first["card-detail"],
        groupDetails: _objectSpread(_objectSpread(_objectSpread({}, {}), state.schema.metadata["group-rules"][first.group]), {}, {
          group: first.group
        }),
        visible: card.some(({
          visible
        }) => visible),
        rows: _filterInstanceProperty(_context3 = _mapInstanceProperty(card).call(card, _ref => {
          let {
              group,
              columns,
              excluded
            } = _ref,
            section = _objectWithoutProperties(_ref, _excluded);
          const [firstPopulated, ...populated] = populateColumns(columns, state.schema.metadata, flow, section["card-title"], excluded);
          return _objectSpread(_objectSpread(_objectSpread({}, section), {}, {
            group,
            columns: [firstPopulated, ...populated]
          }, firstPopulated), {}, {
            visible: section.visible,
            groupDetails: _objectSpread(_objectSpread(_objectSpread({}, {}), state.schema.metadata["group-rules"][group]), {}, {
              group
            })
          });
        })).call(_context3, ({
          visible
        }) => visible)
      };
    });
  },
  [VALIDATIONS_BY_JSON_PATH]: ({
    applicationValidations
  }) => {
    const ignoreKeys = ["agent", "submission-agent", "firm-profile", "line1"];
    const applicationValidationsWithoutIgnoredKeys = _filterInstanceProperty(applicationValidations).call(applicationValidations, validation => !ignoreKeys.some(key => {
      var _context4;
      return _includesInstanceProperty(_context4 = validation.path).call(_context4, key);
    }));
    return _reduceInstanceProperty(applicationValidationsWithoutIgnoredKeys).call(applicationValidationsWithoutIgnoredKeys, (acc, current) => {
      const currentJsonPath = arrayToJsonPath(current.path);
      acc[currentJsonPath] = _objectSpread(_objectSpread({}, current), {}, {
        hashId: `id-${stringToHash(currentJsonPath)}`
      });
      return acc;
    }, {});
  },
  [APPLICATIONS_BY_SUBDOMAIN]: state => {
    return groupBy(state.applications.byId, "agentDetails.subdomain");
  },
  [TOTAL_APPLICATIONS]: state => {
    return state.applications.allIds.length;
  },
  [CONSOLIDATED_REQUEST_FILL_OUT]: state => {
    const {
      fillOut = []
    } = state.consolidatedRequest.metadata || {};
    return fillOut;
  },
  [CONSOLIDATED_REQUEST_CLIENT_USERNAME]: state => {
    const {
      clientUsernameToUse = ""
    } = state.consolidatedRequest.metadata || {};
    return clientUsernameToUse;
  },
  [IS_CONSOLIDATED_REQUEST]: (state, getters) => {
    return getters[CONSOLIDATED_REQUEST_FILL_OUT].length > 0;
  },
  [CONSOLIDATED_REQUEST_SECTIONS]: (state, getters) => {
    const fillOutSections = getters[CONSOLIDATED_REQUEST_FILL_OUT];
    const clientUsernameToUse = getters[CONSOLIDATED_REQUEST_CLIENT_USERNAME];
    const schemaKeysMap = {
      [FILL_OUT_SECTIONS.PERSONAL_INFORMATION]: "main-applicant",
      [FILL_OUT_SECTIONS.MORTGAGE_DETAILS]: "mortgage-details",
      [FILL_OUT_SECTIONS.PROPERTY]: "property"
    };
    const consolidatedRequestSections = _reduceInstanceProperty(fillOutSections).call(fillOutSections, (sections, {
      key,
      applicants
    }) => {
      // check if we need to fill out the main-applicant details
      if (key === FILL_OUT_SECTIONS.PERSONAL_INFORMATION) {
        const mainApplicantIncluded = applicants == null ? void 0 : _includesInstanceProperty(applicants).call(applicants, clientUsernameToUse);
        if (!mainApplicantIncluded) return sections;
      }
      const section = schemaKeysMap[key];
      if (section) sections.push(section);
      return sections;
    }, []);
    if (getters[MAIN_APPLICANT_WILL_FILL_OUT_COAPPLICANTS_DETAILS]) consolidatedRequestSections.push("co-applicants");
    return consolidatedRequestSections;
  },
  [MAIN_APPLICANT_WILL_FILL_OUT_COAPPLICANTS_DETAILS]: (state, getters) => {
    const clientUsernameToUse = getters[CONSOLIDATED_REQUEST_CLIENT_USERNAME];
    const fillOutSections = getters[CONSOLIDATED_REQUEST_FILL_OUT];
    const personalDetailsRequest = _findInstanceProperty(fillOutSections).call(fillOutSections, ({
      key
    }) => key === FILL_OUT_SECTIONS.PERSONAL_INFORMATION);
    if (!personalDetailsRequest) return false;
    const applicants = personalDetailsRequest.applicants || [];
    const coApplicantDetailsRequested = getters[CONSOLIDATED_REQUEST_CO_APPLICANTS_DETAILS_REQUESTED];
    const onlyForMainApplicant = applicants.length === 1 && _includesInstanceProperty(applicants).call(applicants, clientUsernameToUse) && !coApplicantDetailsRequested;
    const coApplicantDetailsRequestedForMainApplicant = applicants.length > 1;
    if (onlyForMainApplicant || coApplicantDetailsRequestedForMainApplicant) return true;
    return !coApplicantDetailsRequested;
  },
  [CONSOLIDATED_REQUEST_CO_APPLICANTS_DETAILS_REQUESTED]: state => {
    const {
      coApplicants = []
    } = state.consolidatedRequest.metadata || {};
    return coApplicants == null ? void 0 : coApplicants.some(coApplicant => {
      return coApplicant.fillOut.some(({
        key
      }) => key === "personal-details");
    });
  },
  [APPLICATION_DETAILS_FLOW]: state => {
    var _state$applicationDet;
    return ((_state$applicationDet = state.applicationDetails) == null ? void 0 : _state$applicationDet.flow) || "";
  },
  [APPLICATION_STATUS]: (state, getters) => {
    var _state$applicationDet2;
    if (getters[IS_CONSOLIDATED_REQUEST]) {
      const {
        status
      } = state.consolidatedRequest.metadata || {};
      return status || "";
    }
    return ((_state$applicationDet2 = state.applicationDetails) == null ? void 0 : _state$applicationDet2.applicationStatus) || "";
  }
};